import React from 'react';

import PageBaseProps from 'types/PageBase';

import { UPDATE_FIXED_CACHE_KEY } from 'modules/selfServices/constants';

import { useSelector } from 'hooks';
import { useUpdateSelfServiceMutation } from 'modules/selfServices/service';

import { getParkingInfo, getParkingMaps } from 'modules/selfServices/selectors';

import PageFooter from 'components/ui/PageFooter';
import ParkingContent from './ParkingContent';

const ParkingInstruction: React.FC<PageBaseProps> = ({
  onNext, onPrev, isPenultimate, shouldDisplayBackButton,
}) => {
  const [, { isLoading }] = useUpdateSelfServiceMutation({ fixedCacheKey: UPDATE_FIXED_CACHE_KEY });
  const parking = useSelector(getParkingInfo);
  const maps = useSelector(getParkingMaps);

  return (
    <div className="main-content">
      <div className="content">
        <ParkingContent maps={maps} {...parking} />
        <PageFooter
          onNext={onNext}
          onPrev={onPrev}
          loading={isLoading}
          isPenultimate={isPenultimate}
          shouldDisplayBackButton={shouldDisplayBackButton}
        />
      </div>
    </div>
  );
};

export default ParkingInstruction;
